module.exports = __webpack_public_path__ + "img/slide_01_en.6d0dd72e.jpg";